<script lang="ts" setup>
import { MateWithChatInfo } from "@/types/chat";
import MateTagGroup from "@/components/mobile/chat/MateTagGroup.vue";
import ChatSceneStateCard from "@/components/mobile/chat/card/ChatSceneStateCard.vue";

const props = defineProps<{
  mate: MateWithChatInfo;
}>();
</script>
<template>
  <div
    class="w-full flex flex-col rounded-lg overflow-hidden shadow-lg border text-start cursor-default shrink-0"
  >
    <div class="flex flex-col cursor-pointer">
      <div
        :style="{
          backgroundImage: `url('${
            mate.bannerAvatarMedia?.url ?? mate.mediaUrl
          }')`,
          backgroundSize: 'cover',
          backgroundPosition: 'top center',
        }"
        class="w-full aspect-[16/9] relative overflow-hidden"
      >
        <!--        <Image-->
        <!--          :fit="'scale-down'"-->
        <!--          :src="mate.bannerAvatarMedia?.url ?? mate.mediaUrl"-->
        <!--          class="pointer-events-none w-full h-full flex"-->
        <!--        />-->
        <div
          class="absolute inset-0 darken-linear-background-b flex flex-col justify-end"
        >
          <div class="font-bold px-2">{{ mate.name }}</div>
          <MateTagGroup :mate="mate" class="m-2" />
        </div>
      </div>
      <div class="bg-base-200 w-full h-24">
        <span class="line-clamp-4 text-base-content/50 m-2">
          {{ mate.bio }}
        </span>
      </div>
    </div>
    <div
      class="bg-base-200 w-full overflow-x-auto shrink-0"
      @touchmove.stop
      @click.stop
    >
      <div class="flex gap-1 px-2 pb-2">
        <ChatSceneStateCard
          v-for="scene in mate.chatScenezz"
          :key="scene.id"
          :scene="scene"
          class="w-[80%] shrink-0"
        />
      </div>
    </div>
  </div>
</template>
<style lang="postcss">
.chat-state.chat-container {
  @apply text-xs;

  & blockquote {
    & h1,
    h2,
    h3,
    h4 {
      @apply text-xs;
    }
  }
}
</style>
